'use client'

import _ from 'lodash'
import slugify from 'slugify'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

import { useParams } from 'next/navigation'
import { useQuery } from "@tanstack/react-query"
import NextLink from 'next/link'

import { Avatar, Divider } from '@/components'
import { Cruz } from '@cruz-com/lookup'
import { pages } from '@/settings'
import { userApi } from '@/api'


export function NavUserSide({ initialData }: { initialData: Cruz.UserDisplay | Cruz.User }) {
  const id = initialData?._id || useParams()?.id

  const { data }: { data: Cruz.UserDisplay | Cruz.User } = useQuery({
    queryKey: [`UserProfile_${id}`],
    queryFn: () => userApi.getProfile(id as string),
    staleTime: 3000,
    initialData,
  })

  const UserInfo = () => {
    return (
      <div className='w-full flex flex-col items-center text-sm/6 mb-4 relative'>
        <Avatar className='size-24' photo_url={data?.photo_url} name={`${data?.first_name} ${data?.last_name}`} />
        <div className='text-lg font-bold truncate mt-3 mb-1'>
          {data?.first_name} {data?.last_name}
        </div>
        <div className='truncate font-light'>
          {data?.location?.city}, {data?.location?.state_abbr}
        </div>
        <div className='truncate font-light'>
          Joined {dayjs(data?.date_create).fromNow()}
        </div>
      </div>
    )
  }

  const NavItem = ({ name, href, count }: { name: string, href: string, count?: number }) => {
    if (_.isEmpty(data)) { return <></> }
    const { _id, first_name, last_name } = data || {}
    href = href.replace('[id]', _id).replace('[name]', slugify(first_name + ' ' + last_name))
    if (_.isUndefined(count) || count === 0) {
      return <></>
    }
    return (
      <li>
        <NextLink hrefLang='en' href={href} className='nav-item'>
          {name}
          <span className='nav-count'>{count}</span>
        </NextLink>
      </li >
    )
  }

  return (
    <>
      <UserInfo />
      <div className="w-full border-t-2 border-zinc-200 dark:border-zinc-600" />
      <ul role="list" className='divide-y dark:divide-zinc-700'>
        <NavItem {...pages.userVehicles} count={data?.statistic?.vehicle_count} />
        <NavItem {...pages.userSpotted} count={data?.statistic?.spotted_count || 0} />
      </ul>
      <Divider />
    </>
  )
}

